import hydrateAll from '@ixn-digital/base-theme-react-framework/render-client';
import manifest from './manifest.gen';

document.addEventListener('DOMContentLoaded', () => {
	hydrateAll(manifest).catch(console.error);
});
